/**
 * Horizontal swipe between main mobile tabs (view-only desk).
 */
import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MOBILE_TAB_PATHS } from '../brand';

export function useSwipeTabs(enabled = true) {
  const nav = useNavigate();
  const loc = useLocation();
  const start = useRef<{ x: number; y: number } | null>(null);
  const TABS = MOBILE_TAB_PATHS;

  useEffect(() => {
    if (!enabled) return;

    const onStart = (e: TouchEvent) => {
      const t = e.touches[0];
      start.current = { x: t.clientX, y: t.clientY };
    };

    const onEnd = (e: TouchEvent) => {
      if (!start.current) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - start.current.x;
      const dy = t.clientY - start.current.y;
      start.current = null;

      if (Math.abs(dx) < 70 || Math.abs(dx) < Math.abs(dy) * 1.4) return;

      const idx = TABS.findIndex((p) =>
        p === '/' ? loc.pathname === '/' : loc.pathname.startsWith(p),
      );
      if (idx < 0) return;

      if (dx < 0 && idx < TABS.length - 1) {
        nav(TABS[idx + 1]);
        if (navigator.vibrate) navigator.vibrate(8);
      } else if (dx > 0 && idx > 0) {
        nav(TABS[idx - 1]);
        if (navigator.vibrate) navigator.vibrate(8);
      }
    };

    window.addEventListener('touchstart', onStart, { passive: true });
    window.addEventListener('touchend', onEnd, { passive: true });
    return () => {
      window.removeEventListener('touchstart', onStart);
      window.removeEventListener('touchend', onEnd);
    };
  }, [enabled, loc.pathname, nav, TABS]);
}

export const MOBILE_TABS = MOBILE_TAB_PATHS;
